import { Quote } from "lucide-react";

const quotes = [
  {
    body: "Monica was the steady hand I didn't know I needed. Those overnight visits gave me my mind back. I'd recommend her to every new mother.",
    name: "Hannah R.",
    role: "First-time mom of Oliver",
  },
  {
    body: "She came in and our home felt softer immediately. Warm meals, gentle help with the baby, and zero judgment when I cried. A literal angel.",
    name: "Priya S.",
    role: "Mama of two",
  },
  {
    body: "From latch help to settling our colicky little one, Monica's calm wisdom changed our postpartum experience entirely.",
    name: "Lauren & Kai T.",
    role: "Welcomed baby Theo",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="section-eyebrow">Words from families</span>
          <span className="gold-divider ml-3 mb-2 align-middle" />
          <h2
            className="font-serif-display mt-4 text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            style={{ color: "var(--text-main)" }}
            data-testid="testimonials-headline"
          >
            Held, rested, <em className="not-italic" style={{ color: "var(--blush)" }}>seen.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
          {quotes.map((q, i) => (
            <figure
              key={q.name}
              className="brand-card p-8 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={28} color="var(--gold)" />
              <blockquote
                className="font-serif-display mt-5 text-xl leading-relaxed"
                style={{ color: "var(--text-main)" }}
              >
                "{q.body}"
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t" style={{ borderColor: "var(--border-soft)" }}>
                <div className="text-sm font-medium" style={{ color: "var(--text-main)" }}>
                  {q.name}
                </div>
                <div className="text-xs mt-1" style={{ color: "var(--text-muted)" }}>
                  {q.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
